import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
    getTaskListApi, getTaskByIdApi, addTaskApi, deleteTaskApi, getUserApi, getProjectListApi, addProjectApi, getProjectByIdApi, completedTaskByIdApi, addUpdateWbseApi,addTimesheetApi,
timesheetListApi,timesheetUserListApi,approveTimesheetApi, wbseListApi, getWbseByIdApi, projectBudgetBreakDownApi, taskDropdownApi
} from "../services/Apis";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { use } from "react";
import { get } from "lodash";


export const useTask = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const initial_page = useSelector((state) => state.globalslice.initial_page);
    const sorting_data = useSelector((state) => state.globalslice.sorting_data);


    const getTaskList = (project_id, rstatus, perPage,) => {
        return useQuery({
            queryKey: ['taskList', { project_id: project_id, rstatus: rstatus, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updateddate', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }],
            queryFn: () => getTaskListApi({ project_id: project_id, rstatus: rstatus, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'updateddate', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }),
            cacheTime: Infinity,
            refetchOnMount: true,
            staleTime: Infinity
        })
    }

    const addTask = useMutation({
        mutationFn: (data) => addTaskApi(data),
        onSuccess: (res) => {
            toast.success(res?.data?.message || "Task added successfully");
            queryClient.invalidateQueries(['taskList'])
            navigate('/crm/task')
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to add task");
        }
    })


    const getTaskById = (id) => {
        return useQuery({
            queryKey: ['taskById', id],
            queryFn: () => getTaskByIdApi(id),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity
        })
    }

    const deleteTask = useMutation({
        mutationFn: (id) => deleteTaskApi(id),
        onSuccess: (res) => {
            toast.success(res?.data?.message || "Task deleted successfully");
            queryClient.invalidateQueries(['taskList'])
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to delete task");
        }
    })

    const getUserDropdown = () => {
        return useQuery({
            queryKey: ['userDropdown', { limit: 5000 }],
            queryFn: () => getUserApi({ limit: 5000 }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };
    const getProjectDropdown = () => {
        return useQuery({
            queryKey: ['projectDropdown', { limit: 5000 }],
            queryFn: () => getProjectListApi({ limit: 5000 }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };
    const getProjectList = () => {
        return useQuery({
            queryKey: ['projectList', { limit: 1000 }],
            queryFn: () => getProjectListApi({ limit: 1000 }),
            cacheTime: Infinity,
            refetchOnMount: true,
            staleTime: Infinity
        })
    }

    const addProject = useMutation({
        mutationFn: (data) => addProjectApi(data),
        onSuccess: (res) => {
            toast.success(res?.data?.message || "Project added successfully");
            queryClient.invalidateQueries(['projectList'])
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to add project");
        }
    })


    const getProjectById = (id) => {
        return useQuery({
            queryKey: ['projectById', id],
            queryFn: () => getProjectByIdApi(id),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity
        })
    }

    const completeTask = useMutation({
        mutationFn: (task_id) => completedTaskByIdApi(task_id),
        onSuccess: () => {
            toast.success("Task marked as completed");

            queryClient.invalidateQueries(["taskList"]);
        },
        onError: () => toast.error("Failed to update task status"),
    });

    const getWbseList = (project_id, perPage) => {
        return useQuery({
            queryKey: ['wbseList', { project_id: project_id, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'wbse_id', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }],
            queryFn: () => wbseListApi({ project_id: project_id, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'wbse_id', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }),
            enabled: !!project_id,
            // Disable cache
            cacheTime: 0,
            staleTime: 0,
            refetchOnMount: true,
            refetchOnWindowFocus: false
        })
    }

    const getWbseDropdown = (project_id) => {
        return useQuery({
            queryKey: ['wbseDropdown', project_id],
            queryFn: () => wbseListApi({ project_id: project_id, limit: 5000 }),
            enabled: !!project_id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const getWbseById = (id) => {
        return useQuery({
            queryKey: ['wbseById', id],
            queryFn: () => getWbseByIdApi(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity
        })
    }

    const addUpdateWbse = useMutation({
        mutationFn: (data) => addUpdateWbseApi(data),
        onSuccess: (res) => {
            toast.success(res?.data?.message || "WBSE saved successfully");
            queryClient.invalidateQueries(['wbseDropdown'])
            queryClient.invalidateQueries(['wbseById'])
            // navigate('/crm/task')
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to save WBSE");
        }
    })

    const useProjectWbseBreakdown = (id) => {
        return useQuery({
            queryKey: ["projectBudgetSummary", id],
            queryFn: () => projectBudgetBreakDownApi(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity
        });

    };
    const addTimesheet = useMutation({
        mutationFn: (data) => addTimesheetApi(data),
        onSuccess: (res) => {
            toast.success(res?.data?.message || "Timesheet added successfully");
            queryClient.invalidateQueries(['timesheetList'])
            queryClient.invalidateQueries(['timesheetUserList'])
            navigate('/crm/timesheets')
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to add Timesheet");
        }
    })

    const getTimesheetList = (weekStart, weekEnd, userIdFromParams, perPage) => {
        return useQuery({
            queryKey: ['timesheetList', { weekStart: weekStart, weekEnd: weekEnd, user_id: userIdFromParams, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'created_at', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }],
            queryFn: () => timesheetListApi({ weekStart: weekStart, weekEnd: weekEnd, user_id: userIdFromParams, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'created_at', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }),
            cacheTime: Infinity,
            refetchOnMount: true,
            staleTime: Infinity
        })
    }

    const getTimesheetUsersList = (week, perPage) => {
        return useQuery({
            queryKey: ['timesheetUserList', { week: week, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'created_at', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }],
            queryFn: () => timesheetUserListApi({ week: week, page: initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'created_at', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, }),
            cacheTime: Infinity,
            refetchOnMount: true,
            staleTime: Infinity
        })
    }
    const approveTimesheet = useMutation({
        mutationFn: (data) => approveTimesheetApi(data),
        onSuccess: (res) => {
            toast.success(res?.data?.message || "Timesheet Approved successfully");
            queryClient.invalidateQueries(['timesheetList'])
            navigate('/crm/timesheets')
        },
        onError: (err) => {
            toast.error(err?.response?.data?.message || "Failed to Approve Timesheet");
        }
    });

    const gettaskDropdown = (project_id) => {
        return useQuery({
            queryKey: ['taskDropdown', project_id],
            queryFn: () => taskDropdownApi({ project_id: project_id, limit: 5000 }),
            enabled: !!project_id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    return {
        getTaskList,
        addTask,
        getTaskById,
        deleteTask,
        getUserDropdown,
        getProjectList,
        addProject,
        getProjectById,
        getProjectDropdown,
        completeTask,
        getWbseList,
        getWbseDropdown,
        getWbseById,
        addUpdateWbse,
        useProjectWbseBreakdown,
        addTimesheet,
        getTimesheetList,
        getTimesheetUsersList,
        approveTimesheet,
        gettaskDropdown
    }
}

// getProjectList